import axios from "axios";
import { API_CREATE_THING } from "../../config/api";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { showAlertInfo } from "shared-components/src/components/feedback/store/alertInfo.actions";
import { alertInfoTypes } from "shared-components/src/components/feedback/alertInfoTypes.enum";
import {
  hideProgress,
  showProgress,
} from "shared-components/src/components/feedback/store/circularProgress.actions";
import {
  FETCH_THING_REQUEST,
  fetchThingFailure,
  fetchThingSuccess,
} from "../../store/actions/thing.actions";

const createThing = async (token, body) => {
  const url = `${API_CREATE_THING}`;
  const headers = {
    "content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  const response = await axios.post(url, body, { headers });
  return response.data;
};

function* handleCreateThing(action) {
  try {
    yield put(showProgress());
    const token = yield select((state) => state.auth.token);
    const body = action?.payload;
    const response = yield call(createThing, token, body);
    yield put(fetchThingSuccess(response));
    yield put(hideProgress());
  } catch (error) {
    const errorMessage = error.response?.data?.error?.message || error.message;
    yield put(
      showAlertInfo({ type: alertInfoTypes.ERROR, message: errorMessage })
    );
    yield put(hideProgress());
    yield put(fetchThingFailure(errorMessage));
  }
}

export function* watchCreateThing() {
  yield takeLatest(FETCH_THING_REQUEST, handleCreateThing);
}
